import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as Data from '../Data';
import * as DatiFide from '../DatiFide';
import { NavLink } from 'react-router-dom';
import { ChiamaAPI, Bottone, Trad, BaseComponent, Tipo, Contesto, CampoData } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IFideAffidamentoListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: DatiFide.CRisAPITipi_FideAffidamento;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class FideAffidamentoLista extends BaseComponent<Glob.IRouteGlobaleProps, IFideAffidamentoListaState> {

    private ParametriFissi: Dati.TListaParametri = {};
    private ID_Anag: number = 0;

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        this.ID_Anag = (this.props.match.params as any).ID_Anag;
        Param.Numero = 10;
        Param.Pagina = 1;

        if ((this.props.match.params as any).ID_Anag != undefined && (this.props.match.params as any).ID_Anag != null && (this.props.match.params as any).ID_Anag != "") {
            this.ParametriFissi["ID_AnagA"] = (this.props.match.params as any).ID_Anag;
        }
        this.state = { Aggiornare: 1, Caricamento: true, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        //Con il bind si pu� scrivere: onChange={this.OnChange}
        //altrimenti va utilizzata la sintassi: onChange={(e) => this.OnChange(e)}
        this.OnChange = this.OnChange.bind(this);

        var M = Glob.GetMenu();
        M.Main = "Home";
        M.ID_MenuMain = 10;
        this.props.SetMenu(M);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [0, 1, 2, 3, 4, 5, 6, 7, 8], orderable: false
                        }
                    ]
                });
            }
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={10}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private StampaBinder(listaBinder: Glob.DatiJSON): string {
        if (this.state.Dati == undefined) {
            return "";
        }

        let ListaBinder: number[] = JSON.parse(listaBinder);
        let R = "";
        for (let ID_Binder of ListaBinder) {
            if (this.state.Dati.Tipi["ListaBinder"][ID_Binder] != null) {
                if (R.length > 0) {
                    R += ", ";
                }
                R += this.state.Dati.Tipi["ListaBinder"][ID_Binder].Valore;
            }
        }
        return R;
    }

    private ImportoAffidamento(dato: DatiFide.CDatiFideAffidamento): React.ReactNode {
        if (dato.ID_TipoFideAffidamento == Glob.Tipi_FA_Affidamento) {
            return <>
                {Trad.TradParam("Provvisorie{1-I}", [dato.LimiteMassimoContraente_Provvisorie])}
                <br />
                {Trad.TradParam("NonProvvisorie{1-I}", [dato.LimiteMassimoContraente_NonProvvisorie])}
            </>;
        }
        else {
            return <>{Trad.TradParam("{1-I}", [dato.LimiteMassimoContraente])}</>;
        }
    }

    private OnRis(sender: ChiamaAPI, dati: DatiFide.CRisAPITipi_FideAffidamento, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={10} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            let html: React.ReactNode[] = [];
            for (let i: number = dati.Dati.length - 1; i >= 0; i--) {
                let dato: DatiFide.CDatiFideAffidamento = dati.Dati[i];
                if (dati.Dati[i - 1] != undefined && dati.Dati[i].ID_FideAffidamento == dati.Dati[i - 1].ID_FideAffidamento) {
                    html.push(<tr data-row="0" key={dato.ID_FideAffidamento + "_" + i}>
                        <td className="TextCenter">
                            {dato.ID_FideAffidamento}
                        </td>
                        <td data-field="AnagDa" className="TextLeft">{dato.AnagDa}</td>
                        <td data-field="AnagA" className="TextLeft">{dato.AnagA}</td>
                        <td data-field="Importo" className="TextRightNoWarap">{this.ImportoAffidamento(dato)}</td>
                        <td data-field="Data" className="TextCenter">{Trad.Trad(dato.Data)}</td>
                        <td data-field="ScadenzaAffidamento" className="TextCenter">{Trad.Trad(dato.ScadenzaAffidamento)}</td>
                        <td data-field="ID_TipoFideAffidamentoEsito" className="TextLeft">{Trad.Trad(dato.ID_TipoFideAffidamentoEsito)}</td>
                        <td data-field="Tipo" className="TextLeft">{Trad.Trad(dato.ID_TipoFideAffidamento)}</td>
                        <td data-field="Binder" className="TextLeft">{this.StampaBinder(dato.ListaBinderJSON)}</td>
                        <td className="TextCenter">
                        </td>
                    </tr>);
                } else {
                    html.push(<tr data-row="0" key={dato.ID_FideAffidamento + "_" + i}>
                        <td className="TextCenter"><a href="#" className="arrow" onClick={(e) => { e.preventDefault(); this.props.history.push("/anagrafica/" + dato.ID_AnagA + "/fideaffidamento/" + dato.ID_FideAffidamento + "/" + Data.DataValoreCompleta(dato.RigaInizio)) }}>
                            {dato.ID_FideAffidamento}
                        </a></td>
                        <td data-field="AnagDa" className="TextLeft">{dato.AnagDa}</td>
                        <td data-field="AnagA" className="TextLeft">{dato.AnagA}</td>
                        <td data-field="Importo" className="TextRightNoWarap">{this.ImportoAffidamento(dato)}</td>
                        <td data-field="Data" className="TextCenter">{Trad.Trad(dato.Data)}</td>
                        <td data-field="ScadenzaAffidamento" className="TextCenter">{Trad.Trad(dato.ScadenzaAffidamento)}</td>
                        <td data-field="ID_TipoFideAffidamentoEsito" className="TextLeft">{Trad.Trad(dato.ID_TipoFideAffidamentoEsito)}</td>
                        <td data-field="Tipo" className="TextLeft">{Trad.Trad(dato.ID_TipoFideAffidamento)}</td>
                        <td data-field="Binder" className="TextLeft">{this.StampaBinder(dato.ListaBinderJSON)}</td>
                        <td className="TextCenter">
                            <a href="#" className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only" onClick={(e) => { e.preventDefault(); this.props.history.push("/anagrafica/" + dato.ID_AnagA + "/fideaffidamento/" + dato.ID_FideAffidamento + "/" + Data.DataValoreCompleta(dato.RigaInizio)) }}>
                                <i className="la la-edit"></i>
                            </a>
                        </td>
                    </tr>);
                }
            }
            return <tbody>{html.reverse()}</tbody>;
        }
    }

    public render() {
        if (!this.ControlloAutorizzazione("FideAffidamentoController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        let infoContesto: Dati.InfoContesto[] = [];
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag));
        let RicercaAnagDa = <Tipo Campo="ParametriUtente[ID_AnagDa]" ID_ChiaveString={this.state.ParametriUtente["ID_AnagDa"] || ""} OnAggiorna={this.OnChange} URL="/api/Anag/RicercaVeloce?id_TipoAnag=2&ricerca=" TradValori />;
        if ((this.props.match.params as any).ID_Anag != undefined && (this.props.match.params as any).ID_Anag != null && (this.props.match.params as any).ID_Anag != "") {
            RicercaAnagDa = <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ParametriUtente[ID_AnagDa]" ID_Chiave={(this.props.match.params as any).ID_Anag} OnAggiorna={this.OnChange} TradValori LinkSelezione="/anagrafica/" Disabilitato />
            this.state.Parametri["AnagA"] = (this.props.match.params as any).ID_Anag;
        }
        return <div>
            <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={(e) => this.OnChange(e)} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-pencil-alt"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">
                                {Trad.Trad("Affidamento")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                                <NavLink to={"/anagrafica/" + (this.props.match.params as any).ID_Anag + "/fideaffidamento/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <input onChange={this.OnChange} type="text" value={this.state.ParametriUtente["ID_FideAffidamento"] || ""} name="ParametriUtente[ID_FideAffidamento]" className="form-control kt-input" placeholder={Trad.Trad("ID")} />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Utente sottoscrittore")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo Campo="ParametriUtente[ID_Utente]" ID_ChiaveString={this.state.ParametriUtente["ID_Utente"] || ""} OnAggiorna={this.OnChange} URL="/api/Utenti/ListaUtenti" />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Tipo")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo Campo="ParametriUtente[ID_TipoFideAffidamento]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoFideAffidamento"] || ""} OnAggiorna={this.OnChange} URL="/api/Tipi/ListaTipi?ID_TipoContesto=FideAffidamento" />
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">

                            <label className="col-lg-1 col-form-label">{Trad.Trad("Affidato")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                {RicercaAnagDa}
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Sottoscrittore")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo Campo="ParametriUtente[ID_AnagA]" ID_ChiaveString={this.state.ParametriUtente["ID_AnagA"] || ""} OnAggiorna={this.OnChange} URL="/api/Anag/RicercaVeloce?id_TipoAnag=8&ricerca=" TradValori LinkSelezione="/anagrafica/" />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("ScadenzaAffidamento")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData Name="ParametriUtente[ScadenzaAffidamento]" Id="ParametriUtente[ScadenzaAffidamento]" Valore={this.state.ParametriUtente["ScadenzaAffidamento"]} OnChange={this.OnChange} ValoreInArrivo={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--center">
                                    <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div>
                    <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                        <thead>
                            <tr className="sfondoTab">
                                <th scope="row" className="TextCenter">ID</th>
                                <th data-field="AnagDa" className="TextLeft">{Trad.Trad("Affidatario")}</th>
                                <th data-field="AnagA" className="TextLeft">{Trad.Trad("Affidato")}</th>
                                <th data-field="Importo" className="TextRight">{Trad.Trad("Importo")}</th>
                                <th data-field="Data" className="TextCenter"> {Trad.Trad("Data")}</th>
                                <th data-field="ScadenzaAffidamento" className="TextCenter"> {Trad.Trad("ScadenzaAffidamento")}</th>
                                <th data-field="Esito" className="TextLeft"> {Trad.Trad("Esito")}</th>
                                <th data-field="Tipo" className="TextLeft"> {Trad.Trad("Tipo")}</th>
                                <th data-field="Binder" className="TextLeft"> {Trad.Trad("Binder")}</th>
                                <th data-field="edit" className="TextCenter">{Trad.Trad("Modifica")}</th>
                            </tr>
                        </thead>
                        <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/FideAffidamento/Ricerca" OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                    </table>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/FideAffidamentoLista.tsx